<template>
  <div :style="style"
    class="loading_line">
    <img src="./gif_01.gif">
    <slot>数据加载中...</slot>
  </div>
</template>
<script>
export default {
  name:'az-loading',
  props: {
    customStyle: {
      type: Object,
      default: function () {
        return {};
      }
    },
    textAlign: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    style() {
      return {
        ...this.customStyle,
        textAlign: this.textAlign
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.loading_line {
  display: inline-block;
  text-align: left;

  img {
    height: 18px;
    vertical-align: middle;
    margin-right: 8px;
    position: relative;
    top: -1px;
  }

  color: #909399;
}

.ag-loading--bigger {
  img {
    height: 40px;
  }
}
</style>
